export class TypePers {

  public nom: string;

  public fonc: string;

  public civilite: string;

  public pren: string;

  constructor() {
    this.nom = '';
    this.fonc = '';
    this.civilite = '';
    this.pren = '';

  }
}
